export const NoCarsFound = ({ onModify }) => {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center animate-fade-in">
      <div className="max-w-xl px-6">
        <h2 className="text-3xl font-bold text-slate-800 mb-4">
          No Cars Found
        </h2>

        <p className="text-slate-600 mb-8">
          We couldn't find any available vehicles for your selected search. Try
          changing your pickup time, dates, or location to see more options.
        </p>

        <button
          onClick={onModify}
          className="px-6 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-hover transition"
        >
          Modify Search
        </button>
      </div>
    </div>
  );
};

